/**
 * A given operation's sync state from GraphQL -> legacy stores.
 *
 * When a GraphQL query returns from the network, we extract fragments and sync them to legacy stores. For
 * performance reasons, we debounce the syncing, which means there are a few ticks between Apollo getting the
 * query result, and legacy stores having the same data.
 *
 * This can lead to a crash when:
 *   - Parent component uses GraphQL to fetch data
 *   - Child component assumes corresponding data is present in legacy store
 *
 * Instead, we use this state to indicate whether a GraphQL query is safe to render.
 */
export enum OpSyncState {
  NOT_OBSERVED = 'NOT_OBSERVED',
  WILL_SYNC = 'WILL_SYNC', // Sync system has observed the operation and will sync it
  SYNC_COMPLETE = 'SYNC_COMPLETE', // All corresponding data is reflected in legacy stores
}
